import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { CognitoService } from './../../services/cognito/cognito.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(public router: Router,  private cognitoService: CognitoService) { }
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const currentRoute = route.routeConfig.path;
    const _DASH_ROLE_MAP_ = ['campaigns', 'users', 'outlet', 'dashreport']
    if (!this.cognitoService.isAuthenticated()) {
      this.router.navigate(['/']);

      return false;
    }
    if (this.cognitoService.isDashRole() && !_DASH_ROLE_MAP_.includes(currentRoute)) {
      this.router.navigate(['/']);

      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/route-guards/auth/auth.guard.ts